/* Spans the viewport and centers the bar, so the bar can use the full width
   before it wraps – a `left: 50%` box shrinks to fit half the viewport. The
   empty sides let clicks through to the page. */
:host {
	position: fixed;
	top: calc(16px + env(safe-area-inset-top, 0px));
	right: 0;
	left: 0;
	z-index: 2147483647;
	display: flex;
	justify-content: center;
	padding: 0 16px;
	font-family: system-ui, -apple-system, "Segoe UI", sans-serif;
	pointer-events: none;
}

.bar {
	display: inline-flex;
	gap: 12px;
	align-items: center;
	padding: 8px 8px 8px 16px;
	color: #fff;
	pointer-events: auto;
	background: rgb(20 20 24 / 92%);
	border-radius: 24px;
	box-shadow: 0 8px 24px rgb(0 0 0 / 24%);
	backdrop-filter: blur(8px);
}

.dot {
	width: 10px;
	height: 10px;
	background: #ef4444;
	border-radius: 50%;
	animation: pulse 1.2s ease-in-out infinite;
}

.label {
	font-size: 13px;
	font-weight: 500;
}

.timer {
	font-size: 13px;
	font-variant-numeric: tabular-nums;
	color: rgb(255 255 255 / 72%);
}

.stop {
	display: inline-flex;
	gap: 6px;
	align-items: center;
	padding: 6px 14px;
	font-family: inherit;
	font-size: 13px;
	font-weight: 600;
	color: #fff;
	cursor: pointer;

	/* #ef4444 gives white text 3.8:1; this red keeps it above 4.5:1. */
	background: #dc2626;
	border: 0;
	border-radius: 16px;
}

.stop:hover {
	background: #b91c1c;
}

.stop:focus-visible {
	outline: 2px solid #fff;
	outline-offset: 2px;
}

@keyframes pulse {
	0%,
	100% {
		opacity: 1;
	}

	50% {
		opacity: 0.35;
	}
}
